module.exports = () => {
  // Must provide react-router routes for redux-router-engine error likely produced by invalid endpoint
  const endpoint = process.env.GQL_ENDPOINT || 'http://localhost:3172/graphql';

  return endpoint;
};
